import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";


export default function Login({ setToken, token }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const navigate = useNavigate();

  async function loginUser(event) {
    event.preventDefault();
    try {
      const response = await fetch('https://fitnesstrac-kr.herokuapp.com/api/users/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          
            username: username,
            password: password,
          
        })
      });
      let result = await response.json();
      console.log(result)
      setToken(result.token);
      // setShowSuccessMessage(true);
      localStorage.setItem("token", result.token);
      if (result.error) {
        alert("Incorrect username or password")
      } else {
        navigate("/Profile");
      }
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <div className="form-container">
      <form onSubmit={(event) => loginUser(event)}>
      <h1>Login</h1>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(event) => setUsername(event.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          />
          <button type="submit">Login</button>
          <div className="signup-message">
          Don't have an account? <Link to="/SignUp">Sign up</Link>
        </div>
        </form>
        {showSuccessMessage && (
        <div className="success-message">Success: Successfully logged in!</div>
      )}
      </div>
    );
  }